import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export abstract class AbstractAppConfigService {
  protected instanceName: string;
  protected apiUrl: string;

  constructor() {}

  instance(): string {
    return this.instanceName;
  }
  baseUrl() {
    return this.apiUrl;
  }
}

export const APP_CONFIG_SERVICE = new InjectionToken<AbstractAppConfigService>(
  'appConfigService'
);

export interface INativeStorageService {
  getItem(key: string): Promise<string>;

  setItem(key: string, value: any): Promise<any>;

  removeItem(key: string): Promise<any>;

  keys(): Promise<Array<string>>;

  clearStorage(): Promise<any>;
}

export const NATIVE_STORAGE_SERVICE = new InjectionToken<INativeStorageService>(
  'nativeStorageService'
);

export const LOCAL_NOTIFICATIONS_SERVICE = new InjectionToken(
  'localNotificationsService'
);

export interface INativeAppVersionService {
  whenReady$: Observable<{
    appName: string;
    packageName: string;
    versionCode: string | number;
    versionNumber: string;
  }>;

  appName(): string;

  packageName(): string;

  versionCode(): string | number;

  versionNumber(): string;
}

export const APP_VERSION_SERVICE = new InjectionToken<INativeAppVersionService>(
  'APP_VERSION_SERVICE'
);

export const FIREBASE_SERVICE = new InjectionToken<IFirebaseService>(
  'FIREBASE_SERVICE'
);

export interface IFirebaseService {
  fetch(cacheExpirationSeconds?: number): Promise<any>;

  activateFetched(): Promise<any>;

  getValue(value: string): Promise<any>;

  setAnalyticsCollectionEnabled(val: boolean): Promise<any>;

  logEvent(type: string, data: any): Promise<any>;

  setScreenName(name: string): Promise<any>;

  setUserId(id: string): Promise<any>;

  setUserProperty(name: string, value: any): Promise<any>;
}
